import React, { Fragment } from 'react'

import {
  WorkOrderReportDashboard,
  WorkOrderReportFilters
} from '../../../interfaces/WorkOrder/WorkOrderReportDashboard'
import { WithoutResultsPanel, SearchCriteriaPanel } from '../../UI'
import { GenericMessagePanel } from '../../UI/GenericMessages/GenericMessagePanel'
import { WorkOrderGraphic } from './WorkOrderGraphic'
import { WorkOrderReport } from './WorkOrderReport'

interface WorkOrderReportElementProps {
  workOrderDashboardData: WorkOrderReportDashboard[]
  values: WorkOrderReportFilters
  error: string | undefined
}

export const WorkOrderReportElement: React.FC<WorkOrderReportElementProps> = ({
  values,
  workOrderDashboardData,
  error
}) => {
  if (error) return <GenericMessagePanel message={error} />

  if (workOrderDashboardData.length <= 0) return <SearchCriteriaPanel />

  if (workOrderDashboardData.filter((item) => item.qty !== 0).length === 0)
    return <WithoutResultsPanel />

  return (
    <Fragment>
      <WorkOrderReport workOrderData={workOrderDashboardData} values={values} />

      <WorkOrderGraphic workOrderData={workOrderDashboardData} />
    </Fragment>
  )
}
